
<div class="main-page-content">
  <div class="main-page-content-block">
    <p-table #dt1
             dataKey="PullRequestNumber"
             [value]="releases"
             [responsive]="true"
             [paginator]="true"
             [rows]="25"
             [loading]="loadingList"
             [showCurrentPageReport]="true"
             currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
             [rowsPerPageOptions]="[10, 25, 50, 100]"
             styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped"
             sortField="ReleaseNotesDate"
             [sortOrder]="-1"
             [expandedRowKeys]="expandedRows">

      <ng-template pTemplate="caption">
        <div class="d-flex justify-content-end">
          <div class="p-2 flex-fill"><h1 class="content-heading-font">Release Notes</h1></div>
          <div class="ml-auto">
            <button class="btn btn-primary" (click)="loadTable()" title="Refresh">
              <i class="pi pi-refresh" [ngClass]="{'pi-spin': loadingList}"></i>
            </button>
            &nbsp;
            <button class="btn btn-primary" (click)="clear(dt1)" title="Clear Filter">
              <i class="pi pi-filter-slash"></i>
            </button>
          </div>
        </div>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th class="text-center" style="width:70px;"></th>
          <th pSortableColumn="PullRequestNumber" class="text-center" style="width:100px;">
            PR <p-sortIcon field="PullRequestNumber"></p-sortIcon>
            <p-columnFilter type="numeric" field="PullRequestNumber" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
          </th>
          <th pSortableColumn="Title" class="text-start">
            Release <p-sortIcon field="Title"></p-sortIcon>
            <p-columnFilter type="text" field="Title" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
          </th>
          <th pSortableColumn="ReleaseNotesDate" class="text-center" style="width:150px;">
            Draft <p-sortIcon field="ReleaseNotesDate"></p-sortIcon>
            <p-columnFilter type="date" field="ReleaseNotesDate" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
          </th>
          <th pSortableColumn="ReleaseNotesAuthor" class="text-center d-none d-md-table-cell" style="width:160px;">
            Author <p-sortIcon field="ReleaseNotesAuthor"></p-sortIcon>
            <p-columnFilter type="text" field="ReleaseNotesAuthor" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
          </th>
          <th class="text-center" style="width:110px;">GitHub</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-item let-expanded="expanded">
        <tr>
          <td class="text-center text-nowrap">
            <p-button type="button" pRipple [pRowToggler]="item" [text]="true" [rounded]="true" [plain]="true" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" />
          </td>
          <td class="text-center text-nowrap fw-bold">
            #{{ item.PullRequestNumber }}
          </td>
          <td class="text-start text-break">
            <a href="#" (click)="openPullRequest(item); $event.preventDefault()">{{ item.Title }}</a>
            <span *ngIf="!item.HasReleaseNotesDraft" class="badge bg-warning text-dark ms-2">Missing draft</span>
          </td>
          <td class="text-center text-nowrap">
            <span title="{{ item.ReleaseNotesDate | date: 'short' }}">{{ getTimeFromNow(item.ReleaseNotesDate) }}</span>
          </td>
          <td class="text-center d-none d-md-table-cell text-truncate" style="max-width:160px;">
            {{ item.ReleaseNotesAuthor || '-' }}
          </td>
          <td class="text-center">
            <button class="btn btn-sm btn-secondary" (click)="openPullRequest(item)" title="Open GitHub PR">
              <i class="pi pi-external-link"></i>
            </button>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="expandedrow" let-item>
        <tr>
          <td colspan="6">
            <div class="release-notes-expanded">
              <div *ngIf="item.HasReleaseNotesDraft" class="release-notes-body" [innerHTML]="item.ReleaseNotesHtml"></div>
              <div *ngIf="!item.HasReleaseNotesDraft" class="alert alert-warning mb-0">
                Release Notes Draft comment was not found for this release candidate PR.
              </div>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="6">No release notes found.</td>
        </tr>
      </ng-template>

      <ng-template pTemplate="paginatorleft">
        <button class="btn btn-primary" (click)="loadTable()" title="Refresh">
          <i class="pi pi-refresh" [ngClass]="{'pi-spin': loadingList}"></i>
        </button>
        &nbsp;
        <button class="btn btn-primary" (click)="clear(dt1)" title="Clear Filter">
          <i class="pi pi-filter-slash"></i>
        </button>
      </ng-template>
    </p-table>
  </div>
</div>
